import React, { useState } from "react";
import { CustomerRegisterDiv } from "./style";
import llogo from "../../../../assets/images/llogo.png";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";

function CustomerRegister() {
  const history = useHistory();

  // const url = "https://devestage.herokuapp.com/patient/register";
  const url = "http://localhost:9191/patient/register"
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  function submit(e) {
    e.preventDefault();
    axios
      .post(url, {
        email: data.email,
        password: data.password,
      })
      .then((res) => {
        console.log(res.data);
        if (data.status === 201) {
          history.push("/login");
        } else {
          alert("E no work");
        }
      });
  }

  function handle(e) {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    console.log(newData);
  }

  return (
    <CustomerRegisterDiv>
      <div className=" row inner-container">
        <div className="col-md-6 left-div">
          <img src={llogo} alt="" />
          <h3>
            Always keep your <br />
            <span>health</span> in check
          </h3>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
        </div>

        <div className="col-md-6 right-div">
          <form onSubmit={(e) => submit(e)}>
            <div className="form-group">
              <input
                onChange={(e) => handle(e)}
                value={data.email}
                type="email"
                className="form-control"
                id="email"
                aria-describedby="emailHelp"
                placeholder=" Enter Email Address or Phone Number"
              />
              <small id="emailHelp" className="form-text text-muted">
                We'll never share your email with anyone else.
              </small>
            </div>

            <div className="form-group">
              <input
                onChange={(e) => handle(e)}
                value={data.password}
                type="password"
                className="form-control"
                id="password"
                placeholder="Password"
              />
            </div>

            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
              />
              <label className="form-check-label" for="exampleCheck1">
                Checking the box shows you comply with medfirst's Terms and
                Condition{" "}
              </label>
            </div>

            <button onSubmit={submit} type="submit" className="btn">
              Create Account
            </button>
          </form>
          <div className="last-part">
            <h4>Have Account?</h4>
            <Link>
              <h4>
                <span>LOGIN</span>
              </h4>
            </Link>
          </div>
        </div>
      </div>
    </CustomerRegisterDiv>
  );
}

export default CustomerRegister;
